import { forwardRef } from 'react'
import { Button as UiButton } from '@edvi-tech/ui/button'
import { cn } from '@edvi-tech/ui/lib/utils'

function mapVariant(variant, color) {
  if (variant === 'outlined') return 'outline'
  if (variant === 'text') return 'ghost'
  if (color === 'secondary') return 'secondary'
  if (color === 'error' || color === 'danger') return 'destructive'
  return 'default'
}

function mapSize(size) {
  if (size === 'small' || size === 'sm') return 'sm'
  if (size === 'large' || size === 'lg') return 'lg'
  return 'default'
}

/**
 * Compatibility Button — same Controls.Button props, backed by @edvi-tech/ui.
 * Accepts MUI-era props (text, startIcon, sx) so existing call sites keep working.
 */
const Button = forwardRef(function Button(props, ref) {
  const {
    text,
    size,
    color,
    variant,
    onClick,
    disabled,
    boldText,
    children,
    startIcon,
    endIcon,
    className,
    type = 'button',
    sx: _sx,
    fullWidth,
    ...other
  } = props

  return (
    <UiButton
      ref={ref}
      type={type}
      variant={mapVariant(variant, color)}
      size={mapSize(size)}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'w-full rounded-lg font-semibold shadow-none',
        mapVariant(variant, color) === 'outline' &&
          'border-[rgba(28,36,52,0.12)] text-[#1c2434] hover:bg-[#f8f9fb]',
        fullWidth === false && 'w-auto',
        className,
      )}
      {...other}
    >
      {startIcon}
      {boldText ? <span className="font-semibold">{text}</span> : text}
      {children}
      {endIcon}
    </UiButton>
  )
})

export default Button
